/**
 * Fordonstyper.
 *
 * Fordonstypen visas alltid i singular. Äldre ärenden har pluralformer
 * sparade (Cars, Boats ...), de mappas om vid visning så att databasen
 * inte behöver ändras.
 */

export const VEHICLE_TYPES = [
   'Car',
   'Motorcycle',
   'Truck / Tractor / Construction',
   'Powersports',
   'Boat',
   'Bus',
   'Gearbox',
]

const SINGULAR = {
   Cars: 'Car',
   Motorcycles: 'Motorcycle',
   'Trucks / Tractor / Construction': 'Truck / Tractor / Construction',
   Trucks: 'Truck',
   Boats: 'Boat',
}

export const formatVehicleType = (type) => SINGULAR[type] || type || ''

/**
 * Tillverkare och modell, t.ex. "Hyundai, i20 5-dörrar".
 * Biltema-uppgifterna används i första hand, annars det användaren angett.
 */
export const getVehicleModel = (row) => {
   const lookup = row?.vehicleLookup
   const make = lookup?.manufacturer || row?.vehicleBrand
   const model = lookup?.model || row?.vehicleSeries
   return [make, model].filter(Boolean).join(', ')
}

/**
 * Årtal för kolumnen Build Year. Det användaren angett används i första hand,
 * annars årsmodellen från Biltema (ärenden med regnummer saknar buildYear).
 */
export const getBuildYear = (row) => {
   if (row?.buildYear) {
      const d = new Date(row.buildYear)
      if (!isNaN(d)) return String(d.getFullYear())
   }
   return row?.vehicleLookup?.modelYear || ''
}

// Regnummer visas alltid med versaler, även i äldre ärenden
export const formatRegNumber = (reg) => String(reg ?? '').toUpperCase()
